/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Utility functions for handling API responses
 */

export const extractApiData = <T>(response: any): T[] => {
    const raw = response?.data?.data ?? response?.data ?? [];
    if (Array.isArray(raw)) return raw as T[];
    if (raw && typeof raw === 'object') return Object.values(raw) as T[];
    return [] as T[];
};

export const extractApiDataSingle = <T>(response: any): T | null => {
    const data = extractApiData<T>(response);
    return data.length > 0 ? data[0] : null;
};

/** Lấy payload object từ response API (hỗ trợ data / data.data). */
export const extractApiPayload = <T>(response: any): T | null => {
    if (response == null) return null;
    const raw = response?.data?.data ?? response?.data ?? response;
    if (raw == null || typeof raw !== 'object' || Array.isArray(raw)) return null;
    return raw as T;
};

export const createApiRequestDTO = (params: Record<string, any>) => {
    return {
        pageNumber: 1,
        pageSize: 100,
        ...params
    };
};

export const handleApiError = (error: any, defaultMessage: string) => {
    console.error('API Error:', error);
    return error?.response?.data?.message || error?.message || defaultMessage;
};
